import { render, staticRenderFns } from "./couponData.vue?vue&type=template&id=0b8e4bfd&class=full-height&"
import script from "./couponData.vue?vue&type=script&lang=js&"
export * from "./couponData.vue?vue&type=script&lang=js&"
import style0 from "./couponData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8e4bfd')) {
      api.createRecord('0b8e4bfd', component.options)
    } else {
      api.reload('0b8e4bfd', component.options)
    }
    module.hot.accept("./couponData.vue?vue&type=template&id=0b8e4bfd&class=full-height&", function () {
      api.rerender('0b8e4bfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/components/couponData.vue"
export default component.exports